module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__text__left--de-c8136bd1b8f5261a6d5c5a1095789cbb.png";